var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAconex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.43463 9.51172V12.8757L5.30035 18.001H0L6.85512 9.51172H9.43463Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 18.001H14.7174L10.5654 12.9109V9.51172H13.0919L20.0001 18.001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43476 8.38356H6.85525C4.71674 5.65926 2.45667 3.0047 0.283522 0.298708C0.207903 0.204305 0.125571 0.108493 0.0708008 0H5.35349L9.43476 5.01957V8.38356Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9294 0L13.0919 8.38356H10.5654V4.98434L14.6467 0H19.9294Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAconex);
export default __webpack_public_path__ + "static/media/aconex.1f5a3b6cd1ce0ae1cc5e3a7bfb7709eb.svg";
export { ForwardRef as ReactComponent };